module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/checkbox/checkbox.component.scss
// module id = ./src/app/modules/base-module/components/checkbox/checkbox.component.scss
// module chunks = 9